var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrossPurple = function SvgCrossPurple(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    fill: "#E7E8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "#555ABE",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3892_3481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4435 17.0462C30.4269 16.6759 30.123 16.3794 29.7509 16.3794H23.748V10.3783V10.3451C23.7332 10.0449 23.5288 9.78517 23.2378 9.70597L17.128 8.02426L17.0967 8.01689L17.0672 8.01136C16.7172 7.94689 16.3709 8.1624 16.2751 8.51422C16.2586 8.57316 16.2512 8.63579 16.2512 8.69841V16.3794H10.2482L10.2169 16.3812C9.84854 16.396 9.55566 16.7017 9.55566 17.0775V22.922V22.9534C9.57224 23.3236 9.87617 23.6201 10.2482 23.6201H16.2512V31.3011C16.2512 31.3637 16.2586 31.4264 16.2751 31.4853C16.3764 31.8574 16.7577 32.0766 17.128 31.9753L23.2378 30.2936C23.5398 30.2107 23.748 29.9362 23.748 29.6213V23.6201H29.7509L29.7822 23.6183C30.1506 23.6017 30.4435 23.296 30.4435 22.922V17.0775V17.0462Z",
    fill: "#575BAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3892_3481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8878,
    height: 24,
    fill: "white",
    transform: "translate(9.55566 8)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrossPurple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cross-purple.c4b280ea834800118778d668aea70ca3.svg";